import { combineReducers } from "@reduxjs/toolkit";

import appointmentsReducer from "./appointmentsSlice";
import authReducer from "./authSlice";
import userSettingsReducer from "./userSettingsSlice";
import scheduleReducer from "./scheduleSlice";
import hostAgencyReducer from "./hostAgencySlice";
import videoCallReducer from "./videoCallSlice";

// reducer;
//const rootReducer = combineReducers({
const appReducer = combineReducers({
  appointments: appointmentsReducer,
  auth: authReducer,

  schedule: scheduleReducer,
  hostAgency: hostAgencyReducer,
  userSettings: userSettingsReducer,
  videoCall: videoCallReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "auth/logOutFulfilled") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
